import { App, fullRoutes } from "@songtradr-sso/shared/common";
import { redirect } from "@songtradr-sso/shared/frontend";
import { Button, useLoadingSplashOverlay } from "@songtradr/design-language";
import { GoogleIcon } from "../AuthButtons.Parts";
import { endpoints, text } from "./GoogleButton.Parts";

export const GoogleButton = () => {
  const { addLoadingSplash } = useLoadingSplashOverlay();

  const followLink = (url: string) => {
    addLoadingSplash(true);
    redirect(url);
  };

  return (
    <Button
      $variant="important"
      type="submit"
      onClick={() =>
        followLink(
          `${endpoints.base}/federated/google?callback=${fullRoutes[App.Core].oauthCallback}`,
        )
      }
      aria-label={text.GOOGLE}
    >
      <GoogleIcon />
      {text.GOOGLE}
    </Button>
  );
};
